import React, { memo, useEffect, useLayoutEffect, useState } from 'react';
import useMenuRedirect from './hooks/useMenuRedirect';
import { useVerifyIsMobile } from './../../hooks/useVerifyIsMobile';
import { ClarovideoLogo } from 'components/ClarovideoLogo';
import { DesktopMenu } from './components/DesktopMenu';
import { MobileMenu } from './components/MobileMenu';
import { DropDownMenu } from './components/MobileMenu/components/DropDownMenu';
import './menu.scss';
import { useSelector } from 'react-redux';
import { selectHeadbandState } from 'selectors/headband';
import getFirstNode from 'utils/getFirstNode';
import { getRegion } from 'utils/Region';
import { Notifications } from 'containers/Notifications';
import { UseSpotlight } from './hooks/useSpotlight';

export const Menu = ({ params = {}, location }) => {
  const { nodes, setInitialNode } = useMenuRedirect();
  const [showDropDownMenu, setShowDropDownMenu] = useState(false);
  const { isMobile } = useVerifyIsMobile(918);
  const { isVisible: isHeadBandVisible } = useSelector(selectHeadbandState);
  const [isSpotlightVisible, setSpotlightVisible, markSpotlightSeen] = UseSpotlight();
  const [headbandHeight, setHeadbandHeight] = useState(0);

  const isHomeuser = () => {
    const firstNode = getFirstNode();
    return location.pathname.indexOf(`/${getRegion()}/${firstNode}`) > -1;
  };

  const handleNotificationToggle = isNotificationCollapsed => {
    if (isSpotlightVisible && isNotificationCollapsed) setSpotlightVisible(false);
    markSpotlightSeen(true);
  }

  //Obtiene el nodo inicial
  useEffect(
    () => {
      if (
        nodes.length === 0 &&
        !params?.node &&
        !location?.pathname?.split('/')?.[2]
      )
        return;
      setInitialNode(params?.node || location?.pathname?.split('/')?.[2]);
    },
    [nodes, params],
  );

  useLayoutEffect(
    () => {
      const checkHeadBand = () => {
        if (document.getElementById('headband'))
          setHeadbandHeight(document.getElementById('headband')?.offsetHeight);
      };

      const observer = new MutationObserver(mutations => {
        mutations.forEach(mut => {
          if (mut.type === 'childList' || mut.type === 'subtree')
            checkHeadBand();
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      return () => observer.disconnect();
    },

    [],
  );

  return (
    <div className={`CDN_MENU ${isSpotlightVisible ? 'spotlight' : ''}`}>
      <Notifications
        isSpotlight={isSpotlightVisible}
        onToggleShowNotification={handleNotificationToggle}
      />

      <header
        className="nav__container"
        id="cv-header"
        style={{
          top: isHeadBandVisible && isHomeuser() ? headbandHeight : 0,
        }}
      >
        <ClarovideoLogo width={176} height={34} classNames="claro-nav-logo" />
        {isMobile ? (
          <>
            <MobileMenu
              isDropDownActive={showDropDownMenu}
              showDropDownMenu={setShowDropDownMenu}
            />
            <DropDownMenu
              isDropDownActive={showDropDownMenu}
              showDropDownMenu={setShowDropDownMenu}
            />
          </>
        ) : (
          <DesktopMenu />
        )}
      </header>
    </div>
  );
};

export default memo(Menu);
